import { ViteReactSSG } from 'vite-react-ssg'
import { routes } from './App'
import './index.css'
import './styles/luxury.css'
import 'primereact/resources/themes/lara-light-blue/theme.css'
import 'primeicons/primeicons.css'

// vite-react-ssg entry. At build time it renders each included route to static
// HTML; in the browser it hydrates into the same interactive SPA. The exported
// `createRoot` is what index.html's module script invokes.
export const createRoot = ViteReactSSG({ routes })
